import { Link } from 'react-router-dom';
import { useConnectors } from '@/lib/api/connectors';
import { Card } from '@/components/ui/Card';
import { buttonClasses } from '@/components/ui/Button';
import { QueryState } from '@/components/QueryState';
import { SkeletonRows } from '@/components/ui/Skeleton';
import { useWorkspacePath } from '@/lib/workspacePath';

export function ConnectorsListPage() {
  const { data, isLoading, error } = useConnectors();
  const ws = useWorkspacePath();

  return (
    <Card
      title="Connectors"
      description="External REST APIs and MCP servers your agents can call during chat."
      actions={
        <Link
          to={ws('connectors', 'new')}
          data-testid="new-connector-link"
          className={buttonClasses({ size: 'sm' })}
        >
          New connector
        </Link>
      }
    >
      <QueryState
        isLoading={isLoading}
        error={error}
        isEmpty={!data || data.length === 0}
        emptyMessage="No connectors yet. Create one to let your agents call an external API."
        loadingLabel="Loading connectors"
        skeleton={<SkeletonRows rows={4} />}
      >
        <ul className="divide-y divide-gray-100">
          {data?.map((connector) => (
            <li
              key={connector.id}
              className="flex items-center justify-between gap-4 py-3"
              data-testid="connector-list-item"
            >
              <div className="min-w-0">
                <p className="truncate font-medium text-gray-900">{connector.name}</p>
                <p className="truncate text-xs text-gray-500">
                  {connector.connector_type === 'mcp'
                    ? `MCP - ${connector.config.server_url}`
                    : connector.connector_type === 'google'
                      ? `Google - ${connector.config.capabilities.join(', ')}`
                      : connector.connector_type === 'slack'
                        ? `Slack - ${connector.config.enabled ? 'enabled' : 'disabled'}`
                        : `${connector.config.method} ${connector.config.url_template}`}
                </p>
              </div>
              <Link
                to={ws('connectors', connector.slug)}
                data-testid="connector-edit-link"
                className={buttonClasses({ variant: 'secondary', size: 'sm' })}
              >
                Edit
              </Link>
            </li>
          ))}
        </ul>
      </QueryState>
    </Card>
  );
}
